import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Nullable } from "../../../../types/utils";
import { TApiOrderDetails, TOrderCostV3, TOrderCostV4 } from "../../../api/endpoints/Order";
import { Button } from "react-bootstrap";
import ButtonWithIcon from "../../Buttons/ButtonWithIcon";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { recalculateOrder } from "../../../store/action-creators/orders";
import useAppDispatch from "../../../hooks/useAppDispatch";
import OrderCostSummaryV3 from "../../../containers/Order/OrderCostSummary/OrderCostSummaryV3";

type Stage = 'prompt' | 'summary';
const STAGES: Array<Stage> = ['prompt', 'summary'];


interface Props {
  order: TApiOrderDetails;
  currentVersion?: Nullable<string>;
  onComplete: () => void;
}

const CostVersion = (props: Props) => {
  const { order, currentVersion, onComplete } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [stage, setStage] = useState<Stage>(STAGES[0]);
  const dispatch = useAppDispatch();

  const onRecalculateClick = useCallback(() => {
    setLoading(true);

    dispatch(recalculateOrder(order)).then((order) => {
      setLoading(false);
      setStage('summary');
    })
  }, [dispatch, setLoading, order]);

  useEffect(() => {
    if ((order.cost as TOrderCostV3 | TOrderCostV4).data.ecquote_version === currentVersion) {
      setStage('summary');
    }
  }, [order]);

  return (
    <div className="cost-version-compatibility">
      {
        stage === 'prompt' &&
        <Fragment>
          <div className="message margin-bottom-md">
            We have updated our costing algorithm that might affect the costs of your order.
          </div>

          <div className="message margin-bottom-md">
            Press the button below to recalculate the costs.
          </div>

          <div className="actions">
            <ButtonWithIcon
              icon={loading ? faSpinner : undefined}
              iconProps={{ spin: true }}
              onClick={onRecalculateClick}>
              Recalculate
            </ButtonWithIcon>
          </div>
        </Fragment>
      }

      {
        stage === 'summary' &&
        <Fragment>
          <h2 className="message margin-bottom-md">
            Summary of updated costs
          </h2>

          <div className="summary margin-bottom-md">
            <OrderCostSummaryV3
              cost={order.cost as TOrderCostV3}
              orderCategory={order.category}
              orderStatus={order.status}
            />
          </div>

          <div className="actions">
            <Button onClick={onComplete}>
              Continue
            </Button>
          </div>
        </Fragment>
      }
    </div>
  )
}

export default CostVersion;
